export default [
    {
        name:'feedback',
        path:'feedback',
        meta: { title: '意见反馈' },
        component: ()=>import('@/pages/feedback/index.vue')
    }
]